import { render, staticRenderFns } from "./SofPage.vue?vue&type=template&id=d1d88944&scoped=true&"
import script from "./SofPage.vue?vue&type=script&lang=js&"
export * from "./SofPage.vue?vue&type=script&lang=js&"
import style0 from "./SofPage.vue?vue&type=style&index=0&id=d1d88944&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d88944",
  null
  
)

export default component.exports